import { render, staticRenderFns } from "./applyManage.vue?vue&type=template&id=36e24265&scoped=true&"
import script from "./applyManage.vue?vue&type=script&lang=js&"
export * from "./applyManage.vue?vue&type=script&lang=js&"
import style0 from "./applyManage.vue?vue&type=style&index=0&id=36e24265&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e24265",
  null
  
)

export default component.exports